import { SupportedFeatures } from "../../features/payslips/services/model/FeatureConfiguration";

export interface EventTypesContextType {
  templates?: MessageType[];
}

export interface EventTypeProviderProps {
  children: React.ReactNode;
}

export enum MessageTypeTrigger {
  PageLoad = "page_load",
  StatusUpdateMatchesNeeded = "status_update_matches_needed",
  StatusUpdateReadyToRelease = "status_update_ready_to_release",
  UploadSuccess = "upload_success",
  UploadFailure = "upload_failure",
  Custom = "custom",
}

export interface MessageType {
  id: number;
  attributes: {
    message_type: "toast" | "snackbar";
    resource_type: SupportedFeatures | "General";
    title: string;
    message_content: string;
    action_text: string | null;
    trigger: MessageTypeTrigger;
    enabled: boolean;
    icon: string;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
    template_id: string | null;
    Type: "Default" | "Info" | "Success" | "Warning" | "Error" | null;
    action_url: string | null;
    auto_close_seconds: number | null;
  };
}

export interface StrapiMessageTypeResponse {
  data: MessageType[];
  meta: {
    pagination: {
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  };
}

export interface ISnackbarsContext {
  addSnackbar: (snackbar: ISnackbar) => boolean;
  removeSnackbar: (snackbarId: string | number) => void;
  removeAllSnackbars: () => void;
  updateSnackbar: (snackbarId: string | number, snackbar: ISnackbar) => void;
  snackbars: ISnackbar[];
}

export interface ISnackbar {
  id: string | number;
  template: MessageType;
  data: any;
  type: "success" | "error" | "warning" | "info";
  expiresAt?: Date;
  maxShowCount?: number;
  showCount?: number;
}
